import React from 'react';
import { Container } from '@mui/material';
import { CaseStatusData } from './types/CaseStatusData';
import { ContactInfo } from './types/ContactInfo';
import { PaymentProvider } from './types/PaymentTypes';
import StatusCard from './components/StatusCard';
import PaymentInfoCard from './components/PaymentInfoCard';
import PaymentAllocatedCard from './components/PaymentAllocatedCard';
import PaymentProcessingCard from './components/PaymentProcessingCard';
import ClosedCard from './components/ClosedCard';
import LoginPromptCard from './components/LoginPromptCard';
import HelpCard from './components/HelpCard';
import CaseHeading from './components/CaseHeading';

type CaseStatusProps = {
  data: CaseStatusData;
  contact: ContactInfo | null;
  payWithoutLoginEnabled: boolean;
  providers: PaymentProvider[];
  providersLoading: boolean;
  confirmLoading: boolean;
  onLoginClick: () => void;
  onPickProvider: () => void;
  onConfirmProvider: (provider: PaymentProvider) => void;
};

const CaseStatus = ({
  data,
  contact,
  payWithoutLoginEnabled,
  providers,
  providersLoading,
  confirmLoading,
  onLoginClick,
  onPickProvider,
  onConfirmProvider,
}: CaseStatusProps) => {
  const payCardProps = {
    data,
    payWithoutLoginEnabled,
    providers,
    providersLoading,
    confirmLoading,
    onPickProvider,
    onConfirmProvider,
  };

  const renderStatusCard = () => {
    switch (data.status) {
      case 'PaymentAllocated':
        return <PaymentAllocatedCard {...payCardProps} />;
      case 'PaymentProcessing':
        return <PaymentProcessingCard data={data} />;
      case 'Open':
        return <PaymentInfoCard {...payCardProps} hidePayNow={!data.payable} />;
      case 'Closed':
        return data.closingReason ? <ClosedCard closingReason={data.closingReason} /> : null;
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 3, px: 2 }}>
      <CaseHeading caseNumber={data.caseNumber} />
      <StatusCard data={data} />
      {renderStatusCard()}
      <LoginPromptCard onLoginClick={onLoginClick} />
      <HelpCard contact={contact} />
    </Container>
  );
};

export default CaseStatus;
